import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

// Renders the template's own title as the modal's <h2> (with a small pencil to edit it in
// place), instead of a separate "Title" field taking up its own row in the form below - this is
// used for the modal-header spot only, the title still lives in the same formData/hasUnsavedChanges
// state each modal already had, just edited from here now.
const EditableModalTitle = ({ value, onChange, placeholder, editLabel }) => {
  const [isEditing, setIsEditing] = useState(false);

  const stopEditing = () => setIsEditing(false);

  if (isEditing) {
    return (
      <input
        type="text"
        className="modal-title-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        onBlur={stopEditing}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            stopEditing();
          }
        }}
        autoFocus
      />
    );
  }

  return (
    <h2 className="modal-title-editable">
      <span className={value ? '' : 'modal-title-placeholder'}>{value || placeholder}</span>
      <button type="button" className="modal-title-edit-btn" onClick={() => setIsEditing(true)} title={editLabel}>
        <FontAwesomeIcon icon={faPen} />
      </button>
    </h2>
  );
};

export default EditableModalTitle;
